function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeriaLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    id: "nigeria_lotto_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 488 295.2",
    style: {
      enableBackground: "new 0 0 488 295.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.2,
    cy: 262.8,
    rx: 126,
    ry: 18.5,
    style: {
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.8,
    cy: 239.8,
    rx: 98.7,
    ry: 14.5,
    style: {
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nigeria_lotto_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.506,
    y1: 65.62,
    x2: 325.495,
    y2: 232.919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    style: {
      stopColor: "#07b3be"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#07a4b1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    style: {
      stopColor: "#067d8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    style: {
      stopColor: "#053e58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    style: {
      stopColor: "#053c56"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 365.7,
    cy: 146.8,
    r: 101.5,
    style: {
      fill: "url(#nigeria_lotto_SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nigeria_lotto_SVGID_00000169546941889155794760000003642433485661062810_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.714,
    y1: 55.916,
    x2: 368.662,
    y2: 162.008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#nigeria_lotto_SVGID_00000169546941889155794760000003642433485661062810_)"
    },
    cx: 376.4,
    cy: 107.6,
    r: 57.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.9 96.2h-22.7l-38 58v13.2h41.3v23.2h19.4v-23.2h11.8v-16.1h-11.8V96.2zM310 151.3l15.3-22.9.1-.1c1.8-3.3 3.5-6.5 5.3-10-.1 3-.2 6.3-.2 9.7v23.3H310zm91.2-56.7c-19.4 0-34.6 15-34.6 34.1 0 17.3 12.3 29.9 29.2 29.9 7 0 12.9-1.8 17.6-5.4-2 6.1-5.4 11.2-10 14.9-4.7 3.8-10.9 6.1-17.7 6.7-4 .4-6.6.6-9.2.3l-1.7-.2v16.8l1.5.1c.6 0 1.8.1 3.4.1 1.9 0 4.5-.1 7.2-.4 12.9-.9 24-5.4 32.2-12.9 10.7-10.2 16.4-25.3 16.4-43.6-.2-24.5-13.6-40.4-34.3-40.4zm-.9 15.9c3.5 0 6.5 1.2 8.8 3.5 3.6 3.6 5.5 10 5.4 18 0 2.2-.4 3.4-.8 4.2-2.7 4.3-7.6 6.8-13.4 6.8-8.1 0-13.4-6-13.5-15.2 0-10.2 5.6-17.3 13.5-17.3z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nigeria_lotto_SVGID_00000183963269247096729910000015242830725378670504_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.937,
    y1: 24.067,
    x2: 132.267,
    y2: 261.381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    style: {
      stopColor: "#07b3be"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    style: {
      stopColor: "#07a4b1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#067d8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#053e58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#053c56"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#nigeria_lotto_SVGID_00000183963269247096729910000015242830725378670504_)"
    },
    cx: 149.2,
    cy: 142.3,
    r: 132
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nigeria_lotto_SVGID_00000080913015264104321590000014904386216587347642_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.637,
    y1: 24.116,
    x2: 153.062,
    y2: 162.087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#nigeria_lotto_SVGID_00000080913015264104321590000014904386216587347642_)"
    },
    cx: 163.1,
    cy: 91.3,
    r: 75.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2 108.2c-16.5 0-27.5 6.1-34.6 12.6 4-14.1 16.2-36.7 52.5-41 6.3-.8 11.3-.8 15.8-.8h2l-.3-28.3-1.8-.1c-4.8-.3-10.1-.2-16.1.5-24.3 2.1-44.5 10.5-60.1 25-19 18.1-29.4 45.1-29.4 75.9 0 44.6 25.3 73.3 64.4 73.3 34.4 0 60.4-26.3 60.4-61.1 0-32.9-21.7-56-52.8-56zm-9.9 27c16.5 0 26.8 11.8 26.8 30.9 0 19.1-9.9 31.9-24.8 31.9-13.6 0-28.4-9.9-29.1-37.8 0-3.7.6-6.5 1.8-9.1 4.8-9.7 14.7-15.9 25.3-15.9z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaLotto);
export default __webpack_public_path__ + "static/media/nigeria_lotto.730f5d100fb2fc8e8c1988bca2401eab.svg";
export { ForwardRef as ReactComponent };